import { MaintenanceForwardingsDirectiveEntryKlass } from '@/features/maintenance/features/workflows/types/forwardings/maintenanceForwardingsDirectiveEntryKlasses.type'

export type ProposalMetricKind = 'date' | 'value'

type DirectiveEntry = {
  label: string
  metric: ProposalMetricKind
}

export const DIRECTIVE_ENTRIES: Partial<Record<MaintenanceForwardingsDirectiveEntryKlass, DirectiveEntry>> = {
  [MaintenanceForwardingsDirectiveEntryKlass.DiagnosticEntry]: { label: 'Diagnóstico', metric: 'date' },
  [MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry]: { label: 'Execução', metric: 'value' },
}

export const directiveEntry = (type?: MaintenanceForwardingsDirectiveEntryKlass | null): DirectiveEntry =>
  (type && DIRECTIVE_ENTRIES[type]) || { label: type ?? '', metric: 'value' }
